import { useEffect } from 'react';
import { getBCP47Language } from '../utils/locale';
import { useLocale } from './useLocale';

const LANG_KEY = 'lang';

// Hook to override the lang attribute set by Next Page Router
export function useSetLang() {
  const locale = useLocale();

  useEffect(() => {
    const documentRoot = document.querySelector<HTMLElement>(':root');
    if (!documentRoot) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === LANG_KEY) {
          const currentLang = documentRoot.getAttribute(LANG_KEY);
          const newLang = getBCP47Language(locale);
          if (currentLang !== newLang) documentRoot.setAttribute(LANG_KEY, newLang);
        }
      }
    });

    observer.observe(documentRoot, { attributes: true });
    return () => observer.disconnect();
  }, [locale]);
}
